import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryInstructionDetail extends BaseModelAPI {
	static entity = 'deliveryinstructiondetail';
	static entityName = 'deliveryinstructiondetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.deliveryInstructionId = '';
			this.deliveryInstruction = {};
			this.partId = '';
			this.part = {};
			this.partName = '';
			this.qtyDelivery = 0;
			this.deliveryOrderDetailId = '';
			this.deliveryOrderDetail = {};
			this.isNeedRegenerateDc = false;
			this.needRepackQty = 0;
			this.qtyActualSupply = 0;
			this.qtyOutstanding = 0;
			this.deliveryInstructionStatusId = '';
			this.deliveryInstructionStatus = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}